import * as z from "zod/v4";

const KlaviyoCredentialsSchema_ = z.object({
  type: z.literal("klaviyo"),
  apiKey: z.string(),
});
export const KlaviyoCredentialsSchema: z.ZodType<KlaviyoCredentials> =
  KlaviyoCredentialsSchema_;
export interface KlaviyoCredentials
  extends z.infer<typeof KlaviyoCredentialsSchema_> {}

const MetaCredentialsSchema_ = z.object({
  type: z.literal("meta"),
  accessToken: z.string(),
  id: z.string(),
});
export const MetaCredentialsSchema: z.ZodType<MetaCredentials> =
  MetaCredentialsSchema_;
export interface MetaCredentials
  extends z.infer<typeof MetaCredentialsSchema_> {}

const GA4CredentialsSchema_ = z.object({
  type: z.literal("ga4"),
  measurementId: z.string(),
  apiSecret: z.string(),
});
export const GA4CredentialsSchema: z.ZodType<GA4Credentials> =
  GA4CredentialsSchema_;
export interface GA4Credentials extends z.infer<typeof GA4CredentialsSchema_> {}

const PostscriptCredentialsSchema_ = z.object({
  type: z.literal("postscript"),
  shopToken: z.string(),
});
export const PostscriptCredentialsSchema: z.ZodType<PostscriptCredentials> =
  PostscriptCredentialsSchema_;
export interface PostscriptCredentials
  extends z.infer<typeof PostscriptCredentialsSchema_> {}

const SnapchatCredentialsSchema_ = z.object({
  type: z.literal("snapchat"),
  accessToken: z.string(),
  snapchatId: z.string(),
});
export const SnapchatCredentialsSchema: z.ZodType<SnapchatCredentials> =
  SnapchatCredentialsSchema_;
export interface SnapchatCredentials
  extends z.infer<typeof SnapchatCredentialsSchema_> {}

const TiktokCredentialsSchema_ = z.object({
  type: z.literal("tiktok"),
  accessToken: z.string(),
  tiktokId: z.string(),
});
export const TiktokCredentialsSchema: z.ZodType<TiktokCredentials> =
  TiktokCredentialsSchema_;
export interface TiktokCredentials
  extends z.infer<typeof TiktokCredentialsSchema_> {}

const GoogleAdsCredentialsSchema_ = z.object({
  type: z.literal("googleads"),
  merchantId: z.string().optional(),
  customerId: z.string(),
  // Written by the OAuth callback, not by the merchant. Each store authorizes
  // separately, so the refresh token is per integration rather than platform
  // wide; accessToken/expiresAt are the cached exchange of it.
  refreshToken: z.string().optional(),
  accessToken: z.string().optional(),
  expiresAt: z.number().optional(),
});
export const GoogleAdsCredentialsSchema: z.ZodType<GoogleAdsCredentials> =
  GoogleAdsCredentialsSchema_;
export interface GoogleAdsCredentials
  extends z.infer<typeof GoogleAdsCredentialsSchema_> {}

const SendLaneCredentialsSchema_ = z.object({
  type: z.literal("sendlane"),
  apiKey: z.string(),
  integrationToken: z.string(),
});
export const SendLaneCredentialsSchema: z.ZodType<SendLaneCredentials> =
  SendLaneCredentialsSchema_;
export interface SendLaneCredentials
  extends z.infer<typeof SendLaneCredentialsSchema_> {}

const AttentiveCredentialsSchema_ = z.object({
  type: z.literal("attentive"),
  attentiveApiKey: z.string(),
});
export const AttentiveCredentialsSchema: z.ZodType<AttentiveCredentials> =
  AttentiveCredentialsSchema_;
export interface AttentiveCredentials
  extends z.infer<typeof AttentiveCredentialsSchema_> {}

const RedoCredentialsSchema_ = z.object({
  type: z.literal("redo"),
  redoAccessToken: z.string(),
  redoStoreId: z.string(),
  redoWidgetId: z.string().optional(),
});
export const RedoCredentialsSchema: z.ZodType<RedoCredentials> =
  RedoCredentialsSchema_;
export interface RedoCredentials
  extends z.infer<typeof RedoCredentialsSchema_> {}

export const IntegrationCredentialsSchema = z.discriminatedUnion("type", [
  KlaviyoCredentialsSchema_,
  MetaCredentialsSchema_,
  GA4CredentialsSchema_,
  PostscriptCredentialsSchema_,
  SnapchatCredentialsSchema_,
  TiktokCredentialsSchema_,
  GoogleAdsCredentialsSchema_,
  SendLaneCredentialsSchema_,
  AttentiveCredentialsSchema_,
  RedoCredentialsSchema_,
]);
export type IntegrationCredentials = z.infer<
  typeof IntegrationCredentialsSchema
>;
